import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { RotateCw } from "lucide-react";

export const UpdateApp = () => {
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const update = async () => {
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker?.getRegistration();
      await reg?.update();
      if (window.caches) await Promise.all((await caches.keys()).map((k) => caches.delete(k)));
      await qc.invalidateQueries();
    } finally {
      window.location.reload();
    }
  };
  return (
    <button data-testid="update-app-button" onClick={update} disabled={busy} title="Scarica l'ultima versione e ricarica"
      className="w-full flex items-center justify-center gap-2 text-xs font-semibold py-2 mb-2 rounded-md text-slate-400 hover:bg-[#1E293B] hover:text-white transition-colors disabled:opacity-50">
      <RotateCw size={14} className={busy ? "animate-spin" : ""} /> {busy ? "Aggiornamento…" : "Aggiorna app"}
    </button>
  );
};
